// extracted by mini-css-extract-plugin
export default {"divider":"Divider_divider__UGs39","horizontal":"Divider_horizontal__-1o2A","vertical":"Divider_vertical__BcHI5"};